'use strict';
module.exports = require('./Accordion.vue');